import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import { type DailyReportsParams, dailyReportsResponse, type UseDailyReports } from './Reports.schema';

const REPORTS_QUERY_KEY = ['reports'];

export const reportsKeys = {
	all: REPORTS_QUERY_KEY,
	daily: (params: DailyReportsParams) => [...REPORTS_QUERY_KEY, 'daily', params] as const,
};

export const useDailyReports = (params: DailyReportsParams, opts: UseDailyReports['opts'] = {}) =>
	useQuery<UseDailyReports['response']>({
		...opts,
		queryKey: reportsKeys.daily(params),
		queryFn: () => API.get('/reports/daily', { params }).then((res) => dailyReportsResponse.parse(res.data)),
		staleTime: 60_000,
	});
